import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M19.25 10V8C19.25 7.30964 18.6904 6.75 18 6.75H16M19.25 14V16C19.25 16.6904 18.6904 17.25 18 17.25H16M13.5 17.25H10.5M8 17.25H6C5.30964 17.25 4.75 16.6904 4.75 16V14M13.5 6.75H10.5M8 6.75H6C5.30964 6.75 4.75 7.30964 4.75 8V10" />
	</SVG>
);
